<ntap-prime-common-itemview [class]="obrazacClass" #itemView></ntap-prime-common-itemview>
<ng-container *ngIf="(viewName$ | async) !== 'fizicki_objekt_create_dlg'">
    <app-objekti-fizickog-objekta [hidden]="itemView.activeTab !== 0"></app-objekti-fizickog-objekta>
</ng-container>